import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const FAQ_ITEMS = [
  {
    question: "Pouvez-vous intervenir rapidement en cas d'urgence ?",
    answer: "Oui ! En cas de fuite, tempête ou infiltration, nous intervenons sous 24h en Wallonie et Brabant Wallon. Appelez-nous directement ou remplissez le formulaire en indiquant l'urgence de votre situation."
  },
  {
    question: "Comment bénéficier des primes Région Wallonne ?",
    answer: "Pour bénéficier des primes habitation, votre logement doit avoir au moins 15 ans et être situé en Wallonie. Pour l'isolation de toiture, aucun audit n'est obligatoire. Nous vous accompagnons gratuitement dans toutes vos démarches administratives et constituons votre dossier de prime."
  },
  {
    question: "Quelles zones couvrez-vous ?",
    answer: "Nous intervenons dans toute la Wallonie ainsi que dans le Brabant Wallon : Liège, Namur, Charleroi, Mons, Wavre, Nivelles, Ottignies, et toutes les communes environnantes."
  },
  {
    question: "Combien de temps durent les travaux de toiture ?",
    answer: "La durée dépend de l'ampleur du projet. Une réparation simple peut être réalisée en quelques heures, tandis qu'un remplacement complet de toiture prend généralement entre 3 et 7 jours ouvrables. Nous vous communiquerons un planning précis après notre visite technique."
  },
  {
    question: "Quelles garanties proposez-vous ?",
    answer: "Tous nos travaux sont couverts par une garantie décennale. Les matériaux que nous utilisons bénéficient également des garanties fabricant (généralement 20 à 30 ans pour les tuiles et ardoises). Nous sommes assurés et certifiés pour tous types de travaux de toiture."
  },
  {
    question: "Le devis est-il vraiment gratuit et sans engagement ?",
    answer: "Absolument ! La demande de devis est 100% gratuite et sans aucun engagement. Un de nos experts vous contacte sous 24h pour discuter de votre projet et planifier une visite technique si nécessaire."
  }
];

const FAQ = () => {
  return (
    <section id="faq" className="py-20 md:py-28 bg-slate-50">
      <div className="max-w-3xl mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="font-heading text-3xl sm:text-4xl font-bold text-slate-900 mb-4">
            Questions fréquentes
          </h2>
          <p className="text-lg text-slate-600">
            Tout ce que vous devez savoir sur nos services
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
          {FAQ_ITEMS.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              className="bg-white rounded-xl border border-slate-200 px-6"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="text-left font-heading font-semibold text-slate-900 hover:text-amber-600 py-5">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="text-slate-600 leading-relaxed pb-5">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-slate-600 mb-4">
            Vous avez d'autres questions ?
          </p>
          <a
            href="#form"
            className="inline-flex items-center gap-2 text-amber-600 hover:text-amber-700 font-semibold transition-colors"
          >
            Contactez-nous via le formulaire
            <span>→</span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
